<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <span class="close-button" @click="hideModal" v-if="showXButton"
              >x</span
            >
            <slot name="header">Product name</slot>
          </div>

          <div class="modal-body">
            <slot name="body">default body</slot>
          </div>

          <div class="modal-footer" v-if="showFooter">
            <slot name="footer">
              <button
                class="button-gemnote button-gemnote--small secondary"
                @click="hideModal"
              >
                <span>Cancel</span>
              </button>

              <button
                class="button-gemnote button-gemnote--small"
                @click="onConfirm"
                :disabled="updatingProductVariants"
              >
                <span>Done</span>
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Modal',
  props: {
    buttonLabel: {
      type: String,
      default: 'OK'
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showXButton: {
      type: Boolean,
      default: true
    },
    colorVariation: {
      type: String,
      default: 'tertiary',
      validator: val => ['primary', 'secondary', 'tertiary'].includes(val)
    }
  },

  computed: {
    ...mapState({
      updatingProductVariants: state => state.ecommerce.updatingProductVariants
    })
  },

  methods: {
    hideModal() {
      this.$store.dispatch('modal/hideModal')
      this.$store.dispatch('ecommerce/resetProductImages', null)
      this.$store.commit('ecommerce/SET_SELECTED_PRODUCT_VARIANTS', null)
    },
    onConfirm() {
      this.$emit('onConfirm')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../global.scss';
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  transform: scale(1);
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 980px;
  min-width: 450px;
  max-height: 95vh !important;
  overflow-y: scroll;
  margin: 0px auto;
  padding: 45px 60px;
  background: #dfdad2;
  border: 1px solid #232220;
  border-radius: 26px;

  text-align: left;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  animation: blowUpModal 0.9s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}

.modal-container::-webkit-scrollbar {
  width: 4px;
}

.modal-container::-webkit-scrollbar-track {
  margin-top: 30px;
  margin-bottom: 30px;
  background: transparent;
}

.modal-container::-webkit-scrollbar-thumb {
  background-color: #a09c95;
}
.modal-header {
  padding: 1rem 3rem 1rem 0rem;
  margin-bottom: 1.5rem;
  text-align: center;
}
.close-button {
  font-family: $editorial;
  position: relative;
  top: -40px;
  right: -50px;
  border: none;
  display: inline-block;
  padding: 0px 0px;
  float: right;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background-color: inherit;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  font-size: 1.5rem;

  &.tertiary {
    color: #25282a;
    font-weight: bold;
  }
}
.modal-body {
  line-height: 1.5rem;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-footer {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: end;

  .button-gemnote {
    font-weight: bold;
    width: auto;
    padding: 0 2rem !important;

    img {
      margin-right: 12px;
      height: 1rem;
    }

    &.secondary {
      background: inherit;
      border: 1px solid $onyx;
      color: $main-6;
    }
    &.tertiary {
      // background: $main-white;
      border: 1px solid $main-white;
      color: $main-white;
    }

    &:disabled {
      // background: #f7f7f7;
      opacity: 0.6;
      cursor: not-allowed;
      // color: #25282a;
    }
  }
}

@media (max-width: 800px) {
  .modal-container {
    min-width: 100%;
    width: 100%;
    padding: 15px;
  }
}
</style>
